import { html, createSignal, navigate } from 'onefold';
import { navSections } from '../config/navigation';
import { BurgerIcon, SearchIcon } from '../components/SvgIcon';

export function Header(): Node {
  const query = createSignal('');
  const showResults = createSignal(false);

  const allLinks = navSections.flatMap(s =>
    s.links.map(l => ({ ...l, section: s.title }))
  );

  const filteredLinks = () => {
    const q = query().toLowerCase().trim();
    if (!q) return [];
    return allLinks.filter(l =>
      l.label.toLowerCase().includes(q) ||
      l.section.toLowerCase().includes(q)
    ).slice(0, 10);
  };

  const handleInput = (e: Event) => {
    query.set((e.target as HTMLInputElement).value);
    showResults.set(query().trim().length > 0);
  };

  const handleResultClick = (path: string) => {
    navigate(path);
    query.set('');
    showResults.set(false);
  };

  const toggleSidebar = () => {
    document.getElementById('sidebar')?.classList.toggle('open');
    document.getElementById('overlay')?.classList.toggle('open');
  };

  return html`
    <header class="header">
      <div class="header-left">
        <button class="sidebar-toggle" onclick=${toggleSidebar} aria-label="Toggle menu">
          ${BurgerIcon()}
        </button>
        <div class="search">
          <span class="s-icon">${SearchIcon()}</span>
          <input
            type="text"
            placeholder="Search docs..."
            oninput=${handleInput}
            onfocus=${() => { if (query().trim()) showResults.set(true); }}
            onblur=${() => setTimeout(() => showResults.set(false), 200)}
          />
          <div class=${() => 'search-results' + (showResults() && filteredLinks().length > 0 ? ' visible' : '')}>
            ${() => filteredLinks().map(link => html`
              <div class="search-result" onclick=${() => handleResultClick(link.path)}>
                <span style="font-size:10px;text-transform:uppercase;color:var(--accent);letter-spacing:0.05em">${link.section}</span><br/>
                ${link.label}
              </div>
            `)}
          </div>
        </div>
      </div>
      <div class="header-actions">
        <a href="#/playground" class="playground-link" onclick=${(e: Event) => { e.preventDefault(); navigate('/playground'); }}>▶ Play</a>
        <a href="https://discord.gg/4WUXzGgan" target="_blank">Discord</a>
        <a href="https://github.com/onefoldjs/onefold" target="_blank">GitHub</a>
        <a href="https://www.npmjs.com/package/onefold" target="_blank">npm</a>
      </div>
    </header>
  `;
}
